import type { UserInfo, UserPhoneNumber } from '@entities/user';
import { GenericResult, publishEvent } from '@salesforce/scv-connector-base';

export class SalesforceUserSetup {
  static init(user: UserInfo) {
    publishEvent({
      eventType: 'LOGIN_RESULT',
      payload: new GenericResult({ success: true }),
      registerLog: false,
    });

    const numbers = user.numbers.map((num: UserPhoneNumber) => {
      return {
        number: num.normalized,
        name: num.name,
        lineId: num.id,
        selected: false,
      };
    });

    numbers.forEach((num: { selected: boolean; lineId: number }) => {
      num.selected = num.lineId === user.default_out_number_id;
    });

    publishEvent({
      eventType: 'MESSAGE',
      payload: {
        type: 'SCV.NUMBER_LIST',
        data: {
          numbers,
        },
      },
      registerLog: false,
    });
  }
}
